<template>
	<el-dialog :title="type+'资源'" :visible.sync="dialogVisible" :before-close="handleClose">
		<el-form :model="dialogModels" label-position="right" label-width="120px">
			<el-form-item label="资源名称">
				<el-input v-model="dialogModels.name" style="width: 70%;"></el-input>
			</el-form-item>
			<el-form-item label="所属产品">
				<el-select placeholder="请选择" filterable v-model="dialogModels.productID" @change="dialogModels.resourceTypeID='';">
					<el-option v-for="item in productList" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="资源分类">
				<el-select placeholder="请选择" v-model="dialogModels.resourceTypeID">
					<el-option v-for="item in getResourceTypeList(dialogModels.productID)" :label="item.name"
						:value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="缩略图">
				<vue-cropper2 @upfile="upicon" :defaultIcon="dialogModels.fileImg" :width="480" :height="270"
					style="margin-left: 14px;" path="ResourceFileImg">
				</vue-cropper2>
			</el-form-item>
			<!-- <el-form-item label="资源描述">
				<el-input v-model="dialogModels.introduce" type="textarea" rows="2"></el-input>
			</el-form-item> -->
			<el-form-item label="上传文件">
				<el-upload class="avatar-uploader" :action="$config.baseURL+'api/ToolApi/UpFiles'"
					:data="{path:'Resource'}" :headers="{'Authorization': 'Bearer ' + $http.token}"
					:show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
					<el-button type="primary" size="mini">选择上传文件</el-button>
				</el-upload>

				<div v-if="upfile">
					<div v-if="dialogModels.extension=='.png'||dialogModels.extension=='.jpg'">
						<img :src="upfile" style="width: 100%;">
					</div>
					<div v-if="dialogModels.extension=='.pdf'">
						<iframe :src="$config.fileurl+dialogModels.fileAddress"
							style="width: 100%;height: 300px;"></iframe>
					</div>
					<div v-if="dialogModels.extension=='.mp4'">
						<video width="100%" height="300px" :src="upfile" controls></video>
					</div>
				</div>

				<span>上传文件类型：.jpg、.png、.MP4、.pdf</span><br>
				<span>上传文件大小：不能超过200MB</span>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="save()">保存</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import vueCropper2 from '@/components/vue-cropper2'

	export default {
		data() {
			return {
				dialogModels: {
					name: '',
					productID: '',
					resourceTypeID: '',
					introduce: '',
					fileImg: '',
					fileAddress: '',
					fileSize: '',
					fileType: '',
					extension: ''
				},
				upfile: ''
			}
		},
		components: {
			vueCropper2
		},
		props: {
			type: {
				type: String
			},
			dialogVisible: {
				type: Boolean,
				default: false
			},
			productList: {
				type: Array
			},
			resourceTypeList: {
				type: Array
			},
			obj: {
				type: Object
			}
		},
		watch: {
			obj(val) {
				this.dialogModels = JSON.parse(JSON.stringify(val))
				this.upfile = this.$config.fileurl + this.dialogModels.fileAddress
				this.dialogModels.fileImg = this.$config.fileurl + this.dialogModels.fileImg
			}
		},
		methods: {
			//上传文件
			upicon(e) {
				this.dialogModels.fileImg = e;
			},
			//上传文件
			handleAvatarSuccess(res, file) {
				if (JSON.stringify(file).indexOf('身份认证失败,未获取授权') > -1) {
					this.$message({
						message: "身份认证失败，刷新页面重试",
						type: 'info'
					})
					window.location.reload()
				}

				this.upfile = URL.createObjectURL(file.raw);
				this.dialogModels.fileAddress = file.response.data
				this.dialogModels.fileSize = file.raw.size
				this.dialogModels.fileType = file.raw.type
				this.dialogModels.extension = this.dialogModels.fileAddress.substring(this.dialogModels
					.fileAddress.lastIndexOf("."), this.dialogModels.fileAddress.length)
			},
			beforeAvatarUpload(file) {
				// console.log(file.type);
				const isType = file.type == 'image/jpeg' || file.type == "image/png" || file.type == 'video/mp4' || file
					.type == 'application/pdf';
				const isLt2M = file.size / 1024 / 1024 < 200;

				if (!isType) {
					this.$message({
						message: '上传文件格式错误!',
						type: 'error'
					});
				}
				if (!isLt2M) {
					this.$message({
						message: '上传文件大小不能超过 200MB!',
						type: 'error'
					});
				}

				return isType && isLt2M;
			},
			//上传文件结束
			async save() {
				if (this.dialogModels.name == '' || this.dialogModels.name == null) {
					this.$message({
						message: "资源名称不能为空",
						type: 'info'
					})
				} else if (this.dialogModels.productID == '' || this.dialogModels.productID == null) {
					this.$message({
						message: "所属产品不能为空",
						type: 'info'
					})
				} else if (this.dialogModels.resourceTypeID == '' || this.dialogModels.resourceTypeID == null) {
					this.$message({
						message: "资源分类不能为空",
						type: 'info'
					})
				} else if (this.dialogModels.fileAddress == '') {
					this.$message({
						message: "未选择文件",
						type: 'info'
					})
				} else {
					this.dialogModels.fileImg = this.dialogModels.fileImg.replace(this.$config.fileurl, '')

					let url = 'api/productResource/EditProduct_Resource'
					if (this.type == '添加') {
						url = 'api/productResource/SaveProduct_Resource'
					}
					this.$http.post(url, this.dialogModels).then(res => {
						if (res.data.code == '1') {
							this.$message({
								message: "资源记录保存成功",
								type: 'success'
							})
							this.handleClose()
						} else {
							this.$message({
								message: "资源记录保存失败",
								type: 'error'
							})
						}
					})
				}
			},
			handleClose() {
				this.$emit('before-close')
			},
			getResourceTypeList(val) {
				return this.resourceTypeList.filter(item => item.productID == val)
			},
		}
	}
</script>

<style>
	.el-form-item__content {
		line-height: 28px;
	}
</style>
